import React from 'react';
import { Box, Chip, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  frame: {
    ...theme.globalClasses.frame,
    marginTop: '5px',
  },
}));

/**
 * The PatientTipBox displays:
 * - tip
 * - description
 * - resources (coming in v2)
 *
 *  If there is no data, the box will not be displayed.
 *
 * @param {object} data
 * @returns
 */
const PatientTipBox = ({ data }) => {
  const classes = useStyles();

  return (
    <>
      {(data && data.tip) || data.description || data.resources ? (
        <Grid
          item
          sx={{ minWidth: '100%', maxWidth: '298px', width: '100%' }}
        >
          <Typography variant={'overline'}>This Week's Tip</Typography>
          <Box className={classes.frame}>
            <Typography variant={'h3'}>{data?.tip}</Typography>
            <Typography>{data?.description}</Typography>
            {data.resources && (
              <Chip
                style={{ lineHeight: '18px' }}
                label={`${data.resources} Resources`}
              />
            )}
          </Box>
        </Grid>
      ) : (
        ''
      )}
    </>
  );
};

export default PatientTipBox;
